<template>
  <div class="modal-schedule-container">
    <sweet-modal ref="modal" overlay-theme="dark">
      <div class="modal-title">결제 기간 {{ item ? '수정' : '등록' }}</div>
      <div class="content" v-if="value">
        <div class="grid-item">
          <div class="grid-title">시작일</div>
          <admin-date-picker :data="value.start_date" @setDate="res => value.start_date = res"></admin-date-picker>
        </div>
        <div class="grid-item">
          <div class="grid-title">종료일</div>
          <admin-date-picker :data="value.end_date" @setDate="res => value.end_date = res"></admin-date-picker>
        </div>
        <div class="grid-item">
          <div class="grid-title">다음 결제예정일</div>
          <admin-date-picker :data="value.next_date" @setDate="res => value.next_date = res"></admin-date-picker>
        </div>
        <div class="grid-item">
          <div class="grid-title">상품</div>
          <div>
            <div class="flex-align" style="gap:8px">
              <select class="input-border" v-model="addProduct.cat" @change="addProduct.id=0">
                <option v-for="(cat, cidx) in option.category" :key="`cat-${cidx}`"
                        :value="cat.value">{{ cat.label }}</option>
              </select>
              <select class="input-border" v-model="addProduct.id">
                <option v-for="(prod, pidx) in optionProduct" :key="`prod-${pidx}`"
                        :value="prod.value">{{ prod.label }}</option>
              </select>

              <div class="btn-add" @click="clickAddProduct">+ 상품 추가</div>
            </div>
            <div v-for="(product,idx) in value.products" :key="`prod-${idx}`"
                 class="item-prod">
              <div class="prod-name"><span>[{{ product.category_name }}]</span> {{ product.name }}</div>
              <i class="material-icons" @click="clickRemoveProduct(idx)">close</i>
            </div>
          </div>
        </div>
        <div class="grid-item">
          <div class="grid-title">결제금액</div>
          <div class="flex-align" style="gap:8px">
            <input type="number" class="input-border" style="height:31px"
                   v-model="value.price" @keyup="e=> value.price = Number(e.target.value)">
            <button class="button" @click="clickApplyPrice">상품금액 반영</button>
          </div>
        </div>
        <div class="grid-item">
          <div class="grid-title">결제수단</div>
          <select class="input-border" v-model="value.pay_method">
            <option v-for="(opt,hidx) in option.payMethod" :key="`paymethod-opt-${hidx}`" :value="opt.value">{{ opt.label }}</option>
          </select>
        </div>
        <div class="grid-item">
          <div class="grid-title">결제주기</div>
          <select class="input-border" v-model="value.date_unit">
            <option v-for="(opt,hidx) in option.dateUnit" :key="`dateunit-opt-${hidx}`" :value="opt.value">{{ opt.label }}</option>
          </select>
        </div>
      </div>
      <div class="button-group" style="padding-top:12px">
        <button class="button is-light" @click="clickCancel">취소</button>

        <button v-if="item"
                class="button is-primary2" @click="clickDelete">삭제</button>

        <button class="button is-primary" @click="clickAccept">확인</button>
      </div>
    </sweet-modal>
  </div>
</template>

<script>
  import { SweetModal } from "sweet-modal-vue";
  export default {
    name: 'ModalServiceSchedule',
    props: {
      item: {
        type: Object
      },
    },
    components: {
      SweetModal
    },
    data() {
      return {
        value: undefined,
        option: {
          category: [],
          product: [],
          payMethod: [
            {value: 0, label: '빌링결제(이니시스)'},
            {value: 1, label: '계좌이체'},
            {value: 2, label: '빌링결제(페이플)'},
            {value: 3, label: '충전금 소진'}
          ],
          dateUnit: [
            {
              label: '1개월',
              value: 1
            },
            {
              label: '3개월',
              value: 3
            },
            {
              label: '6개월',
              value: 6
            },
            {
              label: '12개월',
              value: 12
            }
          ]
        },
        addProduct: {
          cat: 0,
          id: 0
        },
      }
    },
    computed: {
      optionProduct() {
        return this.option.product.filter(i => i.category2 === this.addProduct.cat);
      },
    },
    methods: {
      async init() {
        if(this.item) {
          this.value = this.cloneItem(this.item);
        } else {
          this.value = {
            start_date: '',
            end_date: '',
            next_date: '',
            products: [],
            price: 0,
            date_unit: 1,
            pay_method: 2
          };
        }
        // 카테고리
        if(this.option.category.length === 0) {
          let res = await this.$axios.get('public/category?parent_id=50');
          this.option.category = res.data.map(i => {
            return {
              label: i.name,
              value: i.id
            }
          })
          res = await this.$axios.get('public/product?cat1=50&page_length=200');
          this.option.product = res.data.data.map(i => {
            return {
              label: i.name,
              value: i.id,
              price: i.price.price,
              category2: i.category2
            }
          });
        }
      },
      open() {
        this.init();
        this.$refs.modal.open();
      },
      clickCancel() {
        this.$refs.modal.close();
      },
      async clickAccept() {
        let param = this.cloneItem(this.value);
        let res = undefined;
        if(this.item) {
          res = await this.$axios.patch(this.getUrl(`launchpack/service/${this.$route.query.id}/schedule/${this.item.id}`),
            param);
          this.$emit('update', res.data.item);
        } else {
          res = await this.$axios.post(this.getUrl(`launchpack/service/${this.$route.query.id}/schedule`), param);
          this.$emit('add', res.data.item);
        }
        this.$refs.modal.close();
      },
      async clickDelete() {
        if(confirm(`삭제하시겠습니까?`)) {
          await this.$axios.delete(this.getUrl(`launchpack/service/${this.$route.query.id}/schedule/${this.item.id}`));
          this.$emit('delete');
          this.$refs.modal.close();
        }
      },
      clickAddProduct() {
        if(this.addProduct.id>0) {
          if(this.value.products.findIndex(i=> i.id === this.addProduct.id) === -1) {
            let prod = this.optionProduct.filter(i => i.value === this.addProduct.id)[0];
            this.value.products.push({
              id: this.addProduct.id,
              name: prod.label,
              price: prod.price,
              category2_id: this.addProduct.cat,
              category_name: this.option.category.filter(i => i.value === this.addProduct.cat)[0].label
            })
            this.addProduct.id = 0;
            this.addProduct.cat = 0;
          }
        }
      },
      clickRemoveProduct(idx) {
        removeIndex(this.value.products, idx);
      },
      clickApplyPrice() {
        this.value.price = this.value.products.reduce((a,c) => a + c.price, 0);
      }
    }
  }
</script>

<style lang="stylus" scoped>
  .modal-schedule-container
    color #363636
  .modal-title
    font-size 20px
    font-weight 700
    margin-bottom 36px

  .grid-item
    display grid
    grid-template-columns 120px 1fr
    column-gap 12px
    align-items center
    padding-bottom 12px
  .grid-item:last-child
    margin-bottom 0
    border-bottom 0

  .grid-title
    font-size 14px

  .btn-add
    border 1px solid #dddddd
    font-size 13px
    border-radius 4px
    padding 7px 8px
    cursor pointer
  .btn-add:hover
    background-color #fafafa

  .item-prod
    border 1px solid #dddddd
    border-radius 4px
    margin-top 8px
    display flex
    align-items center
    padding 8px
    font-size 13px
    gap 8px
    .prod-name
      flex 1
    i
      font-size 16px
      cursor pointer

  .button-group
    margin-top 24px
    display flex
    align-items center
    justify-content flex-end
    gap 12px
</style>
<style lang="stylus">
  .sweet-modal-overlay
    -webkit-perspective initial

  .modal-schedule-container
    .sweet-modal.is-alert
      width 544px
    .sweet-modal.is-alert .sweet-content
      padding 28px 32px 16px 32px
</style>
